import React from "react";
import { NavLink } from "react-router-dom";
import AuthContext from "../../../contexts/AuthContext";
import { StudentStatus } from "../../../models/interfaces/student/StudentStatus";
import { StudentGeneralInformationView } from "../../../models/views/identity/StudentGeneralInformationView ";
import StudentService from "../../../services/student/StudentService";
import StudentDailyReports from "../../../services/work-report/StudentDailyReports";
import ConfirmResetReportModal from "../../work-reports/confirm-reset-report-modal/ConfirmResetReportModal";
import CommingSoonModal from "../comming-soon-modal/CommingSoonModal";
import './Nav.scss';
export default class Nav extends React.PureComponent<{}, { userInformation: StudentGeneralInformationView, pageUri: string, showModal: boolean, showReportModal: boolean, hasReport: boolean }> {
    studentDailyReports: StudentDailyReports;
    studentService: StudentService;

    constructor(props: any) {
        super(props);
        this.studentDailyReports = new StudentDailyReports();
        this.studentService = new StudentService();
        this.state = {
            userInformation: {
                education: {},
                personal: {},
                system: {},
            },
            pageUri: '',
            showModal: false,
            showReportModal: false,
            hasReport: false
        };
    }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    closeReportModal = () => {
        this.setState({ showReportModal: false });
    }

    getData = () => {
        let self = this;

        self.studentService.getStudentInformation().then(function (response) {
            if (response.status === 200)
                self.setState({ userInformation: response.data });
        });
    }

    componentDidUpdate() {

    }
    componentDidMount = () => {
        this.getData();
        this.getReportData();
    }

    getReportData = () => {
        let self = this;
        this.studentDailyReports.getStudentReportSaveOptions().then(function (response) {
            self.setState({ hasReport: response.haveTodayReport });
        })
    }

    isActive(uri: string) {
        if (window.location.href.includes("/" + uri))
            return true;
        else return false;
    }

    render(): React.ReactNode {
        let { showReportModal } = this.state;
        return (<>
            <div className="card-menu custom-nav-menu-area">
                <div className="col-12" style={{ padding: "0px" }}>
                    <div className="tk-inline">
                        {this.navMenuRender()}
                    </div >
                </div >
            </div >

            <CommingSoonModal closeModal={this.closeModal} showModal={this.state.showModal} />

            <ConfirmResetReportModal showModal={showReportModal} closeModal={this.closeReportModal} />

        </>);
    }

    navMenuRender() {
        let reportContent;

        let plusButton =( this.state.userInformation.system.status === StudentStatus.Archive && !this.state.userInformation.system.dailyReportSpecialPermission) || this.state.userInformation.system.status === StudentStatus.InitialRegistration
            ? "/PanelUpgrade" : "/RegisterReport";

        if (this.state.hasReport)
            reportContent = (<>
                <div className="col-2" style={{ maxWidth: "none", padding: 0 }} onClick={() => this.setState({ showReportModal: true })}>
                    <div className="icon">
                        <div className="icon-plus">
                            <span className="mdi mdi-plus"></span>
                        </div>
                    </div>
                </div>
            </>);
        else reportContent = (<>
            <NavLink to={plusButton} className={isActive => "col-2 unselected"} style={{ maxWidth: "none", padding: 0 }} >
                <div className="icon">
                    <div className="icon-plus">
                        <span className="mdi mdi-plus"></span>
                    </div>
                </div>
            </NavLink>
        </>);

        return (<>

            <NavLink to={"/Dashboard"} className={isActive =>
                "nav-link col-2 mr-1 " + (!this.isActive("Dashboard") ? " unselected" : " active")
            }>
                <div className="icon">
                    <span className="mdi mdi-view-dashboard"></span>
                </div>
                <div className="subtitle">
                    <label>صفحه من</label>
                </div>
            </NavLink>
            <NavLink to={"/Exams"} className={isActive =>
                "nav-link col-2 mr-2 " + (!this.isActive("Exams") ? " unselected" : " active")
            } >
                <div className="icon">
                    <span className="mdi mdi-book-open-page-variant"></span>
                </div>
                <div className="subtitle">
                    <label>آزمون</label>
                </div>
            </NavLink>
            {reportContent}
            <NavLink to={"/MyPerformance"} className={isActive =>
                "nav-link col-3 " + (!this.isActive("MyPerformance") ? " unselected" : " active")
            }>
                <div className="icon">
                    <span className="mdi mdi-chart-pie" style={{ paddingRight: "13px" }}></span>
                </div>
                <div className="subtitle">
                    <label style={{ width: "60px" }}>عملکرد من</label>
                </div>
            </NavLink>
            <NavLink to={"/StudentExtraCurricular"} className={isActive =>
                "nav-link col-2 mr-2 " + (!this.isActive("StudentExtraCurricular") ? " unselected" : " active")
            }>
                <div className="icon" style={{ textAlign: "center" }}>
                    <span className="mdi mdi-gauge-full"></span>
                </div>
                <div className="subtitle" style={{ textAlign: "center" }}>
                    <label style={{ width: "60px" }}>فوق برنامه</label>
                </div>
            </NavLink>
        </>);
    }
}